<script setup lang="ts">
// Avatar clicável do Header V2 (Figma "Perfil Box"/"Perfil Desktop") — mesmo
// botão (gradiente fixo) usado no mobile e no desktop; extraído pra não
// duplicar a marcação entre as duas seções do Header.vue.
type Props = {
  avatarUrl?: string;
  // 'default' = 88x88, chip "Alterar" em barra full-width (desktop,
  // inalterado). 'mobile' = 85x113, chip "Alterar" fixo (71x22) recuado do
  // fundo (redesign mobile aprovado pelo UX, Figma node 23441:104892/104925)
  // — só o mobile pediu essa aparência/proporção.
  variant?: 'default' | 'mobile';
};

const { variant = 'default' } = defineProps<Props>();

const emit = defineEmits<{ click: [] }>();

// gradiente de fundo do avatar (mesmos 7 stops do Figma)
const AVATAR_GRADIENT =
  'radial-gradient(circle at 50% 50%, #00fffb 0%, #04c3f0 25%, #0887e6 50%, #0969e0 62.5%, #0b4bdb 75%, #0d2dd5 87.5%, #0f0fd0 100%)';
</script>

<template>
  <button
    class="relative flex shrink-0 items-end justify-center overflow-hidden rounded-[12px] border border-v2-blue-light"
    :class="
      variant === 'mobile' ? 'h-[113px] w-[85px] pb-[4px]' : 'size-[88px]'
    "
    :style="{ background: AVATAR_GRADIENT }"
    type="button"
    @click="emit('click')"
  >
    <img
      v-if="avatarUrl"
      alt="Avatar"
      class="absolute inset-0 size-full object-cover"
      :src="avatarUrl"
    />
    <!-- só o texto, sem o lápis: no Figma este chip (node 23458:106874) não
         tem ícone nenhum, e a fonte é 10px bold — não 8px medium -->
    <span
      v-if="variant === 'mobile'"
      class="relative z-10 flex h-[22px] w-[71px] shrink-0 items-center justify-center rounded-full bg-v2-background/60 text-[10px] font-bold text-white"
    >
      Alterar
    </span>
    <span
      v-else
      class="relative z-10 flex w-full items-center justify-center gap-[3px] bg-gradient-to-b from-transparent to-black/70 py-[6px] text-[8px] leading-[10px] font-medium text-white"
    >
      Alterar
      <!-- !important necessário: tailwind.config.js tem `important: true`,
           então o size-[20px] fixo do Icon.vue já compila com !important —
           um style inline sem !important perde pra ele. -->
      <UserV2Icon
        class="text-v2-blue-light"
        name="edit"
        style="width: 9px !important; height: 9px !important"
      />
    </span>
  </button>
</template>
